import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTikTok = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "TikTok",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4213 0.9999C10.4213 0.612978 10.1077 0.299316 9.72073 0.299316C9.71922 0.299316 9.71771 0.299321 9.7162 0.299331C9.71274 0.299353 9.70929 0.2994 9.70584 0.299471C9.32579 0.307391 9.02014 0.617951 9.02014 0.9999C9.02014 1.00216 9.02014 1.00442 9.02015 1.00668V11.3157C9.02015 12.933 7.63666 14.2993 5.86038 14.2993C4.08409 14.2993 2.7006 12.933 2.7006 11.3157C2.7006 9.69837 4.08408 8.33207 5.86038 8.33207C6.2473 8.33207 6.56096 8.01841 6.56096 7.63149C6.56096 7.24457 6.2473 6.93091 5.86038 6.93091C3.37264 6.93091 1.29944 8.86357 1.29944 11.3157C1.29944 13.7678 3.37263 15.7005 5.86038 15.7005C8.34812 15.7005 10.4213 13.7678 10.4213 11.3157V3.97242C10.5583 4.09259 10.7024 4.20528 10.8523 4.31025C11.9033 5.04634 13.2703 5.43381 14.6105 5.43381C14.9974 5.43381 15.3111 5.12015 15.3111 4.73323C15.3111 4.34631 14.9974 4.03265 14.6105 4.03265C13.5202 4.03265 12.4423 3.71326 11.6561 3.16257C10.8813 2.61997 10.4232 1.88435 10.4213 1.00529",
			fill: "currentColor"
		})
	})
});
export default SvgTikTok;
